import React, { useEffect, useState } from "react";
import { Container, makeStyles, Box } from "@material-ui/core";
import Page from "src/components/Page";
import Toolbar from "./Toolbar";
import CategoryAttributeList from "./CategoryAttributeList";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllCategoryAttribute } from "./_categoryAttribute_Action";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const CategoryAttribute = () => {
  const classes = useStyles();

  const [filterFn, setParentFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const dispatch = useDispatch();
  let allFetchData =
    useSelector((state) => state.categoryAttribute._allDetails) || [];

  useEffect(() => {
    dispatch(fetchAllCategoryAttribute());
    // eslint-disable-next-line
  }, []);

  let viewComponent;
  viewComponent = (
    <CategoryAttributeList TableData={allFetchData} filterFn={filterFn} />
  ); //setParentPage={setParentPage} setParentLimit={setParentLimit} setReloadTable={setReloadTable} tableCount={allFetchData.length} />

  return (
    <Page className={classes.root} title="Category Attribute">
      <Container maxWidth={false}>
        <Toolbar setParentFilterFn={setParentFilterFn} />
        <Box mt={3}>{viewComponent}</Box>
      </Container>
    </Page>
  );
};

export default CategoryAttribute;
